import React, { useState, useEffect, useRef } from "react";
import Select from "react-select";
import axios from "axios";
import { useAuth } from "../../../context/auth-context";
import { formatDate, formatToZMW, handlePrint, rootUrl } from "../../../helpers";
import DataTable from "react-data-table-component";
import { FaEye, FaMoneyBill, FaPlus, FaPrint, FaShoppingCart, FaTimes } from "react-icons/fa";
import SlidingDiv from "../../../components/SlidingDiv";
import SupplierStatement from "./SupplierStatement";
import { useOutletContext } from 'react-router-dom';
import AddBillModal from "../bills/addBill";
import { toast } from "react-toastify";
import { MdPayments } from "react-icons/md";
import { customStyles } from "../../../styles";
import PaymentVoucher from "../../../components/PaymentVoucher";

const SupplierManagement = () => {
  const [suppliers, setSuppliers] = useState([]);
  const [searchQuery, setSearchQuery] = useState("");
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedSupplier, setSelectedSupplier] = useState(null);
  const [title, setTitle] = useState('');
  const [output, setOutput] = useState('');
  const [formType, setFormType] = useState(1); // 1: Invoice, 2: Payment
   const [transactions, setTransactions] = useState([]);
      const [filteredCashbooks, setFilteredCashbooks] = useState([]);
        const [filters, setFilters] = useState({
          startDate: '',
          endDate: '',
          bank: '',
          customer: '',
          search: '',
        });
  const [formData, setFormData] = useState({
    name: "",
    contactPerson: "",
    phoneNumber: "",
    email: "",
    address: "",
    type: "",
  });

  const {allData, setAllData} = useOutletContext();
  const auth = useAuth();
 const componentRef = useRef(null);
  const [isSlidingDivOpen, setIsSlidingDivOpen] = useState(false);
    const [showSlidingDiv, setShowSlidingDiv] = useState(false);
  const openSlidingDiv = () => {
    setShowSlidingDiv(true);
  };
  const closeSlidingDiv = () => {
    setShowSlidingDiv(false);
  };
  const toggleSlidingDiv = () => setIsSlidingDivOpen(!isSlidingDivOpen);


    useEffect(() => {
      axios.get(rootUrl(`/getPayments/${auth.user.id}`)) 
      .then((response) => setTransactions(response.data.data))
      .catch((error) => console.error("Error fetching suppliers:", error));
  
    }, []); 


    const display = (obj) => {
      openSlidingDiv();
      setTitle("Payment Voucher");
      setOutput(<PaymentVoucher data={obj} ref={componentRef} />);
    };
  // Handle form changes
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  // Handle modal open/close
  const toggleModal = () => setIsModalOpen((prev) => !prev);

  function isAnyValueEmpty(obj) {
    return Object.values(obj).some(value => 
        value === null || value === undefined || value === ''
    );
}



  // Submit handler
  const handleSubmit = async (e) => {
    e.preventDefault();

    
    
    formData['uid'] = auth.user.id
    try{
       if(isAnyValueEmpty(formData)){
            toast.error("Please ensure to fill in all fields")
            return
          }
          // formData['type'] = 0;
      const response = await axios.post(rootUrl("/addSupplier"), formData)
      if(response.data.status === 200){
        toast.success("Submitted successfully")
        toggleModal();
        setFormData(
          {
            name: "",
            contactPerson: "",
            phoneNumber: "",
            email: "",
            address: "",
            
          }
        )

        axios.get(rootUrl(`/getSuppliers/${auth.user.id}`)) 
      .then((response) => setAllData((prevData) => ({
        ...prevData, 
        suppliers: response.data.data,
      })))
      .catch((error) => console.error("Error fetching suppliers:", error));

      
      }else{
        toast.info(response.data.msg)
      }

    }catch(e){
      toast.error(e?.message)
    }

  };

  

  function viewSupp(id, type, name){

    

    openSlidingDiv()

    if(type === 1){
      setTitle('Supplier Statement')
      setOutput(<SupplierStatement id={id} name={name} />)
    }

    if(type === 2){
      setTitle('Add Payment')
      setOutput(<AddBillModal data={allData} onSubmit={onSubmit} type={2} />)
    }
  }


  
  const onSubmit = async (payload)=>{
    payload['uid'] = auth.user.id

    try{
        const response = await axios.post(rootUrl('/paySupplier'), payload)
        if(response.data.status === 200){
            toast.success("Submitted successfully")
            closeSlidingDiv()
            axios.get(rootUrl(`/getPayments/${auth.user.id}`)) 
      .then((response) => setTransactions(response.data.data))
      .catch((error) => console.error("Error fetching suppliers:", error));
  
        }else{
            toast.error("Something went wrong")
        }
    }catch(e){
        toast.error(e?.message)
    }
}


  const columns = [
     {
       name: 'Sn',
       selector: (row, index) => index + 1,
       sortable: true,
       width: '50px',
     },
     {
       name: 'Date',
       selector: (row) => formatDate(row.date.substring(0, 10)),
       sortable: true,
     },
     {
       name: 'Chart of Account',
       selector: (row) =>
         allData?.budget?.find((a) => a.id == row.coa_id)?.coa || '',
       sortable: true,
     },
     {
       name: 'Bank',
       selector: (row) =>
         allData?.bank?.find((a) => a.id === row.bank)?.name || '',
       sortable: true,
     },
     {
       name: 'Description',
       selector: (row) => row.description || '',
       sortable: true,
     },
     {
       name: 'Voucher #',
       selector: (row) => row.voucher || '',
       sortable: true,
     },{
       name: 'Cheque #',
       selector: (row) => row.cheque || '',
       sortable: true,
     },
     {
       name: 'Payee',
       selector: (row) => allData?.suppliers?.find((a) => a.id == row.paye)?.name || ''
         
       ,
       sortable: true,
     },
     {
       name: 'Project',
       selector: (row) => allData?.projects?.find((a) => a.id == row.proj_id)?.name || ''
       ,
       sortable: true,
     },
     {
       name: 'Debit',
       selector: (row) => (row.type === 'income' ? formatToZMW(row.amount) : 0),
       sortable: true,
     },
     {
       name: 'Credit',
       selector: (row) => (row.type === 'expense' ? formatToZMW(row.amount) : 0),
       sortable: true,
     },
     {
       name: 'Balance',
       selector: (row) => formatToZMW(row.balance || 0),
       sortable: true,
     },
     {
       name: 'Actions',
       cell: (row) => (
         <>
         <button
           className="bg-blue-950 hover:bg-blue-950 text-white px-3 py-1 m-1 rounded"
           onClick={() => display(row)}
         >
           <FaEye/>
         </button>
       </>
       ),
       ignoreRowClick: true,
       allowOverflow: true,
       button: true,
     },
   ];
  
   useEffect(() => {
     let filtered = transactions;
 
     if (filters.startDate) {
       filtered = filtered.filter((row) => {
         const rowDate = new Date(row.date);
         const startDate = new Date(filters.startDate);
       
         // Set the time part to midnight (00:00:00) for both dates
         rowDate.setHours(0, 0, 0, 0);
         startDate.setHours(0, 0, 0, 0);
       
         return rowDate >= startDate;
       });
       
       
     }
     if (filters.endDate) {
       filtered = filtered.filter((row) => {
         const rowDate = new Date(row.date);
         const endDate = new Date(filters.endDate);
       
         // Set the time part to midnight (00:00:00) for both dates
         rowDate.setHours(0, 0, 0, 0);
         endDate.setHours(0, 0, 0, 0);
       
         return rowDate <= endDate;
       });
       
       
     }
     if (filters.bank) {
       filtered = filtered.filter((row) => row.bank == filters.bank);
     }
     if (filters.customer) {
      filtered = filtered.filter((row) => row.paye == filters.customer);
    }
     if (filters.search) {
       filtered = filtered.filter(
         (row) =>
           row.description?.toLowerCase().includes(filters.search.toLowerCase()) ||
         row.voucher?.toLowerCase().includes(filters.search.toLowerCase()) ||
         row.cheque?.toLowerCase().includes(filters.search.toLowerCase()) 
       );
     }
     setFilteredCashbooks(filtered);
   }, [filters, transactions]);
   
   const finalBalance = filteredCashbooks.reduce((total, row) => {
     const amount = parseFloat(row.amount) || 0; 
     return row.type === 'income' ? total + amount : total - amount;
   }, 0);
   const calculateBalance = () => {
     let balance = 0;
     return filteredCashbooks.map((row) => {
       balance += row.type === 'income' ? parseFloat(row.amount) : - parseFloat(row.amount);
       return { ...row, balance };
     });
   };

   const customerOptions = [...new Set(transactions.map(res => res.paye))].map((cust) => {
    const supplier = allData?.suppliers.find(a => a.id == cust);
    return {
      value: cust,
      label: supplier?.name || cust,
    };
  });

  return (
    <div className="w-full flex flex-col bg-white min-h-[400px] rounded-md mt-10 p-5">
      {/* Header */}
      <div className="flex w-full items-center justify-between">
        <h1 className="font-bold text-2xl flex items-center">
                          <MdPayments className="mr-2" /> Payments
                        </h1>
        <div className="flex items-center">
          
          {/* Add Supplier Button */}

          <button onClick={()=>viewSupp(1, 2,'')} 
          className="text-blue-950 border h-[40px] px-3 ml-2 flex items-center rounded-lg text-[12px]"> <FaPlus/> Add Payment</button>
          <button
            onClick={toggleModal}
            className="flex items-center btn bg-blue-950 text-white items-center border border-gray-300 h-[40px] px-3 ml-2 rounded-lg text-[12px]"
          >
            <FaPlus/>
            Add Payee 
          </button>
        </div>
      </div>

      <hr className="my-3"/>

      {/* Supplier Table */}
      <div id="supTable">
       
      <div className="grid grid-cols-3 gap-4 mb-4">
        <input
          type="date"
          className="border px-3 py-2 rounded"
          value={filters.startDate}
          onChange={(e) => setFilters({ ...filters, startDate: e.target.value })}
        />
        <input
          type="date"
          className="border px-3 py-2 rounded"
          value={filters.endDate}
          onChange={(e) => setFilters({ ...filters, endDate: e.target.value })}
        />
        <select
          className="border px-3 py-2 rounded"
          value={filters.bank}
          onChange={(e) => setFilters({ ...filters, bank: e.target.value })}
        >
          <option value="">All CashBooks</option>
          {allData?.bank?.map((bank) => (
            <option key={bank.id} value={bank.id}>{bank.name}</option>
          ))}
        </select>

        <Select
        options={customerOptions}
        placeholder="Payee"
        isClearable
        value={customerOptions.find(option => option.value === filters.customer)}
        onChange={(selectedOption) =>
          setFilters({ ...filters, customer: selectedOption ? selectedOption.value : "" })
        }
      />
        <input
          type="text"
          placeholder="Search..."
          className="border px-3 py-2 rounded"
          value={filters.search}
          onChange={(e) => setFilters({ ...filters, search: e.target.value })}
        />
      </div>
            
            <br/>

            <span className='text-gray-800 pt-5 text-small'>A list of all clients below</span>

      <DataTable
                title=""
                columns={columns}
                data={calculateBalance()}
                pagination
                highlightOnHover
                striped
                responsive
                customStyles={customStyles}
            />
 <div className="text-right font-bold mt-2">
             Balance: {formatToZMW(finalBalance)}
          </div>
      </div>



      {showSlidingDiv && (
              <div
                id="slidingDiv"
                className="bg-white fixed top-0 right-0 h-full w-3/4 overflow-hidden shadow-lg"
              >
                  <FaTimes 
                      onClick={closeSlidingDiv}
                      className="p-1 m-1 text-2xl text-red-500 float-right cursor-pointer"
                  />
                
                <h3 className="m-2 font-semibold text-lg">{title}</h3>
                <hr />
                  <button
                      onClick={() => handlePrint(componentRef)}
                      className="bg-blue-950 text-white px-4 py-2 rounded m-2"
                      >
                      <FaPrint/>
                       </button>
                <div className="h-[90vh] overflow-auto" id="form">{output}</div>
              </div>
            )}
      
     

      {isModalOpen && (
        <div className="fixed inset-0 bg-gray-500 bg-opacity-75 flex items-center justify-center z-50">
          <div className="bg-white rounded p-5 w-[60%] shadow-lg">
            {/* Modal Header */}
            <div className="flex justify-between items-center mb-4 border-b pb-4">
              <h2 className="text-xl font-semibold">
                {selectedSupplier ? "Edit Supplier" : "Add New Payee"}
              </h2>
              <button
                onClick={toggleModal}
                className="text-gray-500 hover:text-gray-700"
              >
                <i className="fa fa-times" aria-hidden="true"></i>
              </button>
            </div>
            {/* Modal Body */}
            <div className="grid grid-cols-2 gap-4">
              <select 
                className="border rounded p-2"
                value={formData.type}
                onChange={handleInputChange}
                name="type"
                >
                <option value="">Select Type</option>
                <option value="1">Supplier</option>
                <option value="2">Employee</option>
              </select>
              <input
                name="name"
                placeholder={parseInt(formData.type) === 2?'Employee Firstname': 'Supplier Name'}
                value={formData.name}
                onChange={handleInputChange}
                className="border rounded p-2"
              />
              <input
                name="contactPerson"
                placeholder={parseInt(formData.type) === 2?'Employee Lastname': 'Contact Person'}
                value={formData.contactPerson}
                onChange={handleInputChange}
                className="border rounded p-2"
              />
              <input
                name="phoneNumber"
                placeholder="Phone Number"
                value={formData.phoneNumber}
                onChange={handleInputChange}
                className="border rounded p-2"
              />
              <input
                name="email"
                placeholder="Email"
                value={formData.email}
                onChange={handleInputChange}
                className="border rounded p-2"
              />
              <input
                name="address"
                placeholder="Address"
                value={formData.address}
                onChange={handleInputChange}
                className="border rounded p-2"
              />
              {/* Other fields based on form type */}
              {formType === 2 && (
                <>
                  <Select
                    name="budget"
                    placeholder="Select Budget"
                    options={[]} // Populate options dynamically
                    onChange={(option) =>
                      setFormData((prev) => ({ ...prev, budget: option.value }))
                    }
                  />
                  <textarea
                    name="description"
                    placeholder="Description"
                    value={formData.description}
                    onChange={handleInputChange}
                    className="border rounded p-2 col-span-2"
                  />
                </>
              )}
            </div>
            {/* Modal Footer */}
            <div className="flex justify-end mt-4">
              <button
                onClick={toggleModal}
                className="bg-gray-100 text-gray-700 px-4 py-2 rounded"
              >
                Close
              </button>
              <button
                onClick={handleSubmit}
                className="bg-blue-500 text-white px-4 py-2 rounded ml-2"
              >
                Submit
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default SupplierManagement;
